import { styled } from "goober";
import { ClickButton } from "../ClickButton";
import { Icon } from "../Icon";
import { Text } from "../Text";

const Row = styled("div")`
  display: flex;
  align-items: center;
  gap: 8px;
  height: 28px;
  padding: 6px 10px 6px 8px;
`;

const Group = styled("div")`
  display: flex;
  align-items: center;
  gap: 6px;
`;

const ThumbButton = styled(ClickButton)`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
  border-radius: 50%;
  color: var(--text-secondary);
  cursor: pointer;

  &:hover {
    background: color-mix(in srgb, var(--text-secondary) 12%, transparent);
    color: var(--text-primary);
  }
`;

function ModelFeedback({
  submitted,
  onFeedback,
}: {
  submitted: boolean;
  onFeedback: (feedback: "up" | "down") => void;
}) {
  if (submitted) {
    return (
      <Text variant="text-small" color="var(--text-secondary)">
        Thanks for the feedback
      </Text>
    );
  }
  return (
    <Group>
      <Text variant="text-small" color="var(--text-secondary)">
        How did the AI do in this session?
      </Text>
      <ThumbButton aria-label="Thumbs up" onClick={() => onFeedback("up")}>
        <Icon name="thumbs-up" size={12} />
      </ThumbButton>
      <ThumbButton aria-label="Thumbs down" onClick={() => onFeedback("down")}>
        <Icon name="thumbs-down" size={12} />
      </ThumbButton>
    </Group>
  );
}

export function ModelFeedbackRow({
  submitted,
  onFeedback,
}: {
  submitted: boolean;
  onFeedback: (feedback: "up" | "down") => void;
}) {
  return (
    <Row>
      <ModelFeedback submitted={submitted} onFeedback={onFeedback} />
    </Row>
  );
}
